module.exports = __webpack_public_path__ + "static/img/feather-alert-circle.9f91f7b6.png";